export const LOCALE_KEYS = [
  'ko_KR',
  'en_US',
  'th_TH',
  'zh_TW',
  'ja_JP',
  'hi_IN',
  'tl_PH',
  'ar_SA',
] as const;

export const MAX_SPECIALTY_TAGS = 3;
